// 👉 à placer dans un fichier séparé pour plus tard (ex: constants.js)
export const VPS_BASE_URL = "https://72.61.107.125:8090/preview/foodallergycard-app.com/assets";
